import { render, staticRenderFns } from "./SlidingSidebar.vue?vue&type=template&id=7a206af6&scoped=true"
import script from "./SlidingSidebar.vue?vue&type=script&lang=js"
export * from "./SlidingSidebar.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/sliding-sidebar.css?vue&type=style&index=0&id=7a206af6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a206af6",
  null
  
)

export default component.exports